import { type ReactNode } from 'react';
import { THRESHOLDS } from '../utils/chart-color';

const LINE =
  'pointer-events-none absolute inset-x-0 border-t border-dashed border-white/[0.08]';

export function ChartThresholds({ maxH }: { maxH: number }): ReactNode {
  if (maxH <= 0) return null;
  return (
    <>
      {THRESHOLDS.map((v) => {
        const pct = (v / maxH) * 100;
        if (pct > 100) return null;
        return <div key={v} className={LINE} style={{ bottom: `${pct}%` }} />;
      })}
    </>
  );
}
